import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, Spinner, InputGroup, FormControl, Modal } from 'react-bootstrap';
import { useCreateUserMutation, useLoginMutation } from '../../redux/services/authApi'; // Assuming you have a createUser endpoint in your API
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import headerImage from "../../assets/images/MysticTan_Unity_Logo_Black.png"
import EulaDocument from '../../components/eula/EulaDocument';
import { acceptEula } from '../../logic/eula/eulaAcceptance';
import "../login/login.css"
const AccountCreation = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    confirm_password: '',
  });
  const [accept, setAccept] = useState(false)
  const [hasntClicked, setHasntClicked] = useState(true)
  const [showEula, setShowEula] = useState(false)
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const [createUser, { isLoading, isSuccess, isError, error }] = useCreateUserMutation();
  const [login, { isLoading: loginLoading, isSuccess: loginSuc, isError: loginIsError, error: loginError }] = useLoginMutation();
  const [validationError, setValidationError] = useState('');
  const { t } = useTranslation("translation", { keyPrefix: "accountCreations" });
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    // Force login on create user. The user just agreed to the EULA on this form,
    // so once login gives us the new user id, record that acceptance — otherwise
    // the app-wide EulaGate would immediately re-prompt them after sign-up.
    if (!isSuccess) return;
    (async () => {
      try {
        const result = await login({ email: formData.email, password: formData.password }).unwrap();
        const uid = result?.payload?.id;
        if (uid != null) acceptEula(uid);
      } catch (err) {
        /* login failed; the gate will prompt for the EULA after a manual login */
      }
    })();
  }, [isSuccess])
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#+^()[\]{}|\\:;"'<>,.~`\-_+=])[A-Za-z\d@$!%*?&#+^()[\]{}|\\:;"'<>,.~`\-_+=]{8,}$/;
    return passwordRegex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationError('');

    if(!accept){
      setValidationError(t("noAccept", 'Please accept the End User License Agreement to continue.'));
      return;
    }

    if (!validatePassword(formData.password)) {
      setValidationError(t("passwordvalidate.length", 'Password must be at least 8 characters long, contain one uppercase letter, one number, and one special character.'));
      return;
    }

    if (formData.password !== formData.confirm_password) {
      setValidationError(t("passwordvalidate.nomatch", "Passwords do not match"));
      return;
    }

    try {
      await createUser(formData);
    } catch (err) {
      console.log(err);
    }
  };

  const tryAgree = (e) => {
    e.preventDefault()
    if (hasntClicked) {
      setValidationError(t("HasntClicked", "You must view the End User License Agreement before you can agree"));
    } else {
      setAccept(!accept)
    }
  }
  return (
    <div className=''>
      <div className='unityHeader'>
        <div className="login-header-image"><img src={headerImage}></img></div>
      </div>
      <div className='prettyLogin'>
        <div className="formContainer">
          <div className="header">
            <h1 >{t("signup", "Sign up")}</h1>
          </div>
          {!isSuccess &&
            <Form onSubmit={handleSubmit}>
              <Row className="formInput">
                <Col>
                  <Form.Group controlId="formFirstName">
                    <Form.Control
                      type="text"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                      placeholder={t("firstName", "First Name")}
                      required
                      disabled={isSuccess || isLoading}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="formInput">
                <Col>
                  <Form.Group controlId="formLastName">
                    <Form.Control
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      placeholder={t("lastname", "Last Name")}
                      required
                      disabled={isSuccess || isLoading}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="formInput" controlId="formEmail">
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("email", "Email Address")}
                  required
                  disabled={isSuccess || isLoading}
                />
              </Form.Group>

              <Form.Group className="formInput" controlId="formPassword">
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder={t("password", "Password")}
                  required
                  disabled={isSuccess || isLoading}
                />
              </Form.Group>

              <Form.Group className="formInput" controlId="formConfirmPassword">
                <Form.Control
                  type="password"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  placeholder={t("confirmPass", "Confirm Password")}
                  required
                  disabled={isSuccess || isLoading}
                />
              </Form.Group>

              <Form.Group className="formInput checkboxInput" controlId="privacyPolicy" style={{ background: "none" }}>
                <div style={{display:"flex", width:"100%", justifyContent:"space-between", alignItems:"center",
                border: "var(--bs-border-width) solid var(--bs-border-color)",
                borderRadius: "var(--bs-border-radius)",
                padding: "0.375rem 0.75rem",
                background: "white"
                }}>
                  <div
                    onClick={() => {
                      setHasntClicked(false)
                      setValidationError('')
                      setShowEula(true)
                    }}
                    style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    {isTouchDevice ? t("tapToViewEula", "Tap to view the EULA") : t("clickToViewEula", "Click to view the EULA")}
                  </div>
                  <div 
                  style={{display:"flex", alignItems:"center"}}
                  onClick={(e) => { tryAgree(e) }}>
                    <div
                      style={{  textAlign: "right", paddingRight: "20px" }}
                    >{t("privacyPolicyAccept", "I accept")}</div>
                    <input type='checkbox'
                    style={{pointerEvents: "none"}}
                      checked={accept}
                      onChange={(e) => {
                        console.log(e)
                      }}
                      disabled={isSuccess || isLoading} ></input>
                  </div>
                </div>
                <div style={{ marginTop: '0.4rem', fontSize: '0.85rem' }}>
                  <span
                    onClick={() => window.open("https://sunless.com/policies/privacy-policy", '_blank', "noopener,noreferrer")}
                    style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    {t("viewPrivacy", "View our Privacy Policy")}
                  </span>
                </div>

              </Form.Group>

              <Button variant="primary" type="submit" disabled={isLoading} className="loginButton">
                {isLoading ? <Spinner animation="border" size="sm" /> : t("createButton", "Create")}
              </Button>
            </Form>
          }

          {validationError && (
            <Alert variant="danger">
              {validationError}
            </Alert>
          )}
          {isSuccess && (
            <Alert variant="success" className="mt-3">
              {t("successAlert", "Account created successfully")}
            </Alert>
          )}
          {isError && (
            <Alert variant="danger" className="mt-3">
              {error?.data?.msg}
            </Alert>
          )}
          <div className='bottomPrettyContent'>
          <Button variant="primary" type="submit" disabled={isLoading} className="loginButton" onClick={(e) => {
              e.preventDefault();
              navigate("/login")
            }}>
                {isLoading ? <Spinner animation="border" size="sm" /> : t("haveLogin", "Already have an account? Login!")}
              </Button>
          </div>
        </div>
      </div>
      <div className='footerContent'>

      </div>

      <Modal show={showEula} onHide={() => setShowEula(false)} centered scrollable size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t("eulaTitle", "End User License Agreement")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EulaDocument />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEula(false)}>
            {t("close", "Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AccountCreation;
